var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b;
import { Component, Vue, Prop, Watch } from "vue-facing-decorator";
import { BatteryReplacementEstimationClient, CompaniesClient, SitesClient, SettingsClient, ReportScheduleModel, GetBatteryReplacementEstimationQuery } from "@/app/api/battery-portal-api";
import { State } from "vuex-facing-decorator";
import { LoginState } from "@/app/store/modules/login.state";
import { Notifier } from "@//common/utils/notifier";
import { HttpHelper } from "@/app/utils/http-helper";
import { DownloadUtil } from "@/app/utils/download-util";
import moment from "moment";
import { useForm } from 'vee-validate';
import * as yup from 'yup';
const batteryReplacementEstimationClient = new BatteryReplacementEstimationClient(window.apiUrl);
const companyClient = new CompaniesClient(window.apiUrl);
const siteClient = new SitesClient(window.apiUrl);
const settingsClient = new SettingsClient(window.apiUrl);
let BatteryReplacementEstimationReportFilterVue = class BatteryReplacementEstimationReportFilterVue extends Vue {
    constructor() {
        super(...arguments);
        this.working = false;
        this.companies = [];
        this.sites = [];
        this.query = new GetBatteryReplacementEstimationQuery({
            periodInMonths: 3,
            includeOhmicColumns: false,
            ohmicRiseThreshold: 30
        });
    }
    created() {
        this.getLookups();
    }
    ;
    mounted() {
        this.setFieldValue("periodInMonths", this.query.periodInMonths);
        this.setFieldValue("ohmicRiseThreshold", this.query.ohmicRiseThreshold);
        this.loadReportScheduleQuery();
    }
    ;
    getLookups() {
        this.working = true;
        let promises = [
            companyClient
                .getListGET()
                .then(response => {
                this.companies = (response || []).map((item) => {
                    return {
                        value: item.companyId,
                        text: item.companyName || ""
                    };
                });
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
            }),
            siteClient
                .getListForUser()
                .then(response => {
                this.sites = response;
            })
        ];
        Promise.all(promises).then(() => {
            this.working = false;
        });
    }
    ;
    getQuery() {
        if (!this.validateParameters())
            return null;
        this.query.timezoneOffset = moment().utcOffset();
        return this.query;
    }
    ;
    validateParameters() {
        try {
            if (!this.query.companyId) {
                Notifier.onError("Please select a company");
                return false;
            }
            if (!this.query.siteId) {
                Notifier.onError("Please select a site");
                return false;
            }
            if (!this.query.periodInMonths || this.query.periodInMonths < 1 || this.query.periodInMonths > 60) {
                Notifier.onError("Period in Months must be between 1 and 60");
                return false;
            }
            return true;
        }
        catch (e) {
            console.error(e);
            return false;
        }
    }
    exportToPdf() {
        if (this.working)
            return;
        var query = this.getQuery();
        if (query == null)
            return;
        const handleSubmitAction = this.handleSubmit(() => {
            this.working = true;
            batteryReplacementEstimationClient.downloadBatteryReplacementEstimationAsPDF(query)
                .then(response => {
                if (!response) {
                    Notifier.onWarning("Could not download report data.");
                    return;
                }
                let blob = new Blob([response.data], { type: 'application/pdf;base64' });
                let url = URL.createObjectURL(blob);
                var popUp = window.open(url, '_blank');
                if (popUp == null || typeof (popUp) == 'undefined') {
                    alert('Please disable your pop-up blocker and try again.');
                }
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        });
        handleSubmitAction();
    }
    ;
    exportToCsv() {
        if (this.working)
            return;
        var query = this.getQuery();
        if (query == null)
            return;
        const handleSubmitAction = this.handleSubmit(() => {
            this.working = true;
            batteryReplacementEstimationClient.downloadBatteryReplacementEstimationAsCsv(query)
                .then(response => {
                if (!response) {
                    Notifier.onWarning("Could not download report data.");
                    return;
                }
                DownloadUtil.handleFileDownload(response);
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        });
        handleSubmitAction();
    }
    ;
    getScheduleButtonLabel() {
        return this.reportScheduledModel ? "Update schedule" : "Schedule";
    }
    ;
    onReportScheduledModelChanged() {
        this.loadReportScheduleQuery();
    }
    ;
    onCompanyIdChanged() {
        if (!this.working) {
            this.query.siteId = null;
            this.loadCompanySettings();
        }
    }
    loadCompanySettings() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.query.companyId) {
                this.query.ohmicRiseThreshold = 30;
                this.setFieldValue("ohmicRiseThreshold", this.query.ohmicRiseThreshold);
                return;
            }
            try {
                const settings = yield settingsClient.getBatteryReplacementEstimationSettingsForCompany(this.query.companyId);
                if (settings) {
                    this.query.ohmicRiseThreshold = settings.ohmicRiseThreshold || 30;
                    this.setFieldValue("ohmicRiseThreshold", this.query.ohmicRiseThreshold);
                }
            }
            catch (ex) {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            }
        });
    }
    setValidationFields() {
        this.setFieldValue("periodInMonths", this.query.periodInMonths);
        this.setFieldValue("ohmicRiseThreshold", this.query.ohmicRiseThreshold);
    }
    schedule() {
        var reportQuery = this.getQuery();
        var queryString = JSON.stringify(reportQuery);
        this.$emit(this.reportScheduledModel ? "updateSchedule" : "schedule", queryString);
    }
    ;
    loadReportScheduleQuery() {
        var _a, _b, _c, _d, _e;
        if (!this.reportScheduledModel)
            return;
        var queryString = (_b = (_a = this.reportScheduledModel) === null || _a === void 0 ? void 0 : _a.query) !== null && _b !== void 0 ? _b : "";
        try {
            var query = JSON.parse(queryString);
            this.working = true;
            this.query.companyId = query.companyId;
            this.query.siteId = query.siteId;
            this.query.periodInMonths = (_c = query.periodInMonths) !== null && _c !== void 0 ? _c : 3;
            this.query.includeOhmicColumns = (_d = query.includeOhmicColumns) !== null && _d !== void 0 ? _d : false;
            this.query.ohmicRiseThreshold = (_e = query.ohmicRiseThreshold) !== null && _e !== void 0 ? _e : 30;
            this.$nextTick(() => {
                this.working = false;
            });
            this.setValidationFields();
        }
        catch (ex) {
            console.error(ex);
        }
    }
    ;
    get selectedCompanyId() {
        return this.companies.filter(item => {
            return item.value == this.query.companyId;
        })[0] || null;
    }
    ;
    set selectedCompanyId(item) {
        if (!item)
            return;
        this.query.companyId = item.value;
    }
    ;
    get sitesFiltered() {
        var filteredSites = this.sites.filter(site => !this.query.companyId || site.companyId == this.query.companyId);
        let sites = (filteredSites || []).map(item => {
            return {
                value: item.siteId,
                text: item.siteName || ""
            };
        });
        //sites = [{ value: null, text: `All sites` }].concat(sites);
        return sites;
    }
    get selectedSite() {
        return this.sitesFiltered.filter(item => {
            return item.value == this.query.siteId;
        })[0] || null;
    }
    ;
    set selectedSite(item) {
        if (!item)
            return;
        this.query.siteId = item.value;
    }
    ;
    get isClientAdministrator() {
        return this.loginState.isClientAdministrator;
    }
    ;
};
__decorate([
    State("loginModule"),
    __metadata("design:type", typeof (_a = typeof LoginState !== "undefined" && LoginState) === "function" ? _a : Object)
], BatteryReplacementEstimationReportFilterVue.prototype, "loginState", void 0);
__decorate([
    Prop(),
    __metadata("design:type", typeof (_b = typeof ReportScheduleModel !== "undefined" && ReportScheduleModel) === "function" ? _b : Object)
], BatteryReplacementEstimationReportFilterVue.prototype, "reportScheduledModel", void 0);
__decorate([
    Watch("reportScheduledModel"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], BatteryReplacementEstimationReportFilterVue.prototype, "onReportScheduledModelChanged", null);
__decorate([
    Watch("query.companyId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], BatteryReplacementEstimationReportFilterVue.prototype, "onCompanyIdChanged", null);
BatteryReplacementEstimationReportFilterVue = __decorate([
    Component({
        name: "BatteryReplacementEstimationReportFilterVue",
        emits: ["schedule", "updateSchedule"],
        setup() {
            const { errors, handleSubmit, defineInputBinds, setFieldValue } = useForm({
                validationSchema: yup.object({
                    periodInMonths: yup.number().integer().min(1).max(60).required(),
                    ohmicRiseThreshold: yup.number().min(0).max(100)
                })
            });
            const periodInMonthsVal = defineInputBinds('periodInMonths');
            const ohmicRiseThresholdVal = defineInputBinds('ohmicRiseThreshold');
            return {
                errors,
                handleSubmit,
                setFieldValue,
                periodInMonthsVal,
                ohmicRiseThresholdVal
            };
        }
    })
], BatteryReplacementEstimationReportFilterVue);
export default BatteryReplacementEstimationReportFilterVue;
